// Public entry point, for Node.js and for the browser via webpack/browserify.
//
// `require("./mappers")` is the lazy registry: only NROM is present until a ROM
// declares another board, at which point that mapper's module is required. Code
// inside the emulator goes through `Mappers._load()`, so loading a game only
// ever pulls in the one mapper it needs.
//
// This file is different: it hands the raw registry to library consumers, who
// have always been able to index it directly (`jsnes.Mappers[4]`). Pre-loading
// here keeps that working. Nothing inside `src/` imports this module, so an app
// that only wants the emulator still gets lazy loading.
const Controller = require("./controller");
const NES = require("./nes");
const ROM = require("./rom");
const Mappers = require("./mappers");

Mappers._loadAll();

// __JSNES_VERSION__ is injected by webpack's DefinePlugin from package.json. The
// typeof test keeps this module loadable under plain Node (the test suite), where
// the constant does not exist.
var VERSION = typeof __JSNES_VERSION__ !== "undefined" ? __JSNES_VERSION__ : "";

if (typeof window !== "undefined") {
  window.jsnes = {
    Mappers: Mappers,
    Controller: Controller,
    NES: NES,
    ROM: ROM,
    VERSION: VERSION,
  };
}

module.exports = {
  Controller: Controller,
  NES: NES,
  ROM: ROM,
  Mappers: Mappers,
  VERSION: VERSION,
};
